import { useParams } from "react-router";

import useDestinationById from "@/hooks/useDestinationById";
import { LoadedDestinationInfo } from "@/types/global";

// A quick hook to grab destination based on the `:configId` route parameter.
export function useDestinationConfigAtRouteId():
  | LoadedDestinationInfo
  | undefined {
  const { configId } = useParams<{ configId: string }>();
  const destinationConfig = useDestinationById(configId);

  return destinationConfig;
}
